import type { FC, ReactNode } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import texts from '../../VehicleListV2.texts.json';
import { useScrollToStartOfStickyBar } from '../hooks/useStickyFilterBar';

import styles from './DropdownPanel.module.scss';

const LocalT = new MDText(texts.dropdownActions);

const handlePreventMultiSelectClose = (e: React.MouseEvent) => e.preventDefault();

interface DropdownPanelProps {
	children: ReactNode;
	clearDisabled: boolean;
	hasChanged: boolean;
	hasStoreValue: boolean;
	onApply: () => void;
	onClear: () => void;
}

export const DropdownPanel: FC<DropdownPanelProps> = ({
	children,
	clearDisabled,
	hasChanged,
	hasStoreValue,
	onApply,
	onClear,
}) => {
	const scrollToFilterBar = useScrollToStartOfStickyBar();

	const handleApply = () => {
		onApply();
		if (hasChanged) {
			scrollToFilterBar();
		}
	};

	const handleClear = () => {
		onClear();
		if (hasStoreValue) {
			scrollToFilterBar();
		}
	};

	return (
		<div>
			{children}
			<div className={styles.dropdownActions} onMouseDown={handlePreventMultiSelectClose}>
				<div className={styles.clearButtonWrapper}>
					<Button
						fullWidth
						disabled={clearDisabled}
						label={LocalT.translate('clear')}
						onClick={handleClear}
						size="small"
						variant="secondary"
					/>
				</div>
				<div className={styles.applyButtonWrapper}>
					<Button fullWidth label={LocalT.translate('apply')} onClick={handleApply} size="small" variant="primary" />
				</div>
			</div>
		</div>
	);
};
